<div class="channel-list" [class.channel-list-dock]="variant === 'dock'">
  <!-- Header -->
  <div class="cl-header" *ngIf="showHeader">
    <span class="cl-header-title">Messages</span>
  </div>

  <!-- Search (hidden in dock — parent provides search) -->
  <div class="cl-search" *ngIf="variant !== 'dock'">
    <i class="pi pi-search"></i>
    <input
      type="text"
      placeholder="Search channels…"
      [(ngModel)]="searchQuery"
      (ngModelChange)="onSearchInput()"
      class="cl-search-input"
    />
  </div>

  <div class="cl-scroll">
    <!-- Chats tab: Direct Messages -->
    <div class="cl-section" *ngIf="showChatsSection">
      <div class="cl-section-label">
        <span>{{ viewTab === 'chats' ? 'Recent Chats' : 'Direct Messages' }}</span>
        <button class="cl-add-btn" (click)="openNewDmDialog()" title="New direct message">
          <i class="pi pi-plus"></i>
        </button>
      </div>
      <div
        *ngFor="let ch of filteredDirect"
        class="cl-item"
        [class.cl-item--active]="isChannelOpenOrActive(ch.id)"
        (click)="selectChannel(ch)"
        >
        <span class="cl-item-avatar" [class.cl-item-avatar--no-image]="!ch.profile_pic_url">
          <span class="cl-item-avatar-initials" aria-hidden="true">{{ getChannelDisplayName(ch).charAt(0).toUpperCase() }}</span>
          <img
            *ngIf="ch.profile_pic_url"
            [clAvatar]="ch.profile_pic_url"
            (error)="onAvatarError($event)"
            [alt]="getChannelDisplayName(ch)"
          />
        </span>
        <div class="cl-item-body">
          <span class="cl-item-name">{{ getChannelDisplayName(ch) }}</span>
          <span *ngIf="ch.last_message" class="cl-item-preview">{{ ch.last_message }}</span>
        </div>
        <span *ngIf="ch.unread_count > 0" class="cl-badge">{{ ch.unread_count }}</span>
      </div>
      <div
        *ngIf="directHasMore"
        #directSentinel
        class="cl-scroll-sentinel"
        aria-hidden="true"
      ></div>
      <div *ngIf="directLoadingMore" class="cl-loading cl-loading--inline">
        <i class="pi pi-spin pi-spinner"></i>
      </div>
      <div *ngIf="filteredDirect.length === 0 && !loading" class="cl-section-empty">
        No direct messages
      </div>
    </div>

    <!-- Channels tab: Group + Entity Linked (sub-tabs when dock Channels is active) -->
    <ng-container *ngIf="showChannelsSection">
      <div class="cl-subtabs" *ngIf="viewTab === 'channels'">
        <button
          type="button"
          class="cl-subtab"
          [class.cl-subtab--active]="channelsSubTab === 'group'"
          (click)="setChannelsSubTab('group')"
        >
          <span>Group</span>
          <span *ngIf="groupUnread > 0" class="cl-subtab-badge">
            {{ groupUnread > 99 ? '99+' : groupUnread }}
          </span>
        </button>
        <button
          type="button"
          class="cl-subtab"
          [class.cl-subtab--active]="channelsSubTab === 'entity_linked'"
          (click)="setChannelsSubTab('entity_linked')"
        >
          <span>Entity Linked</span>
          <span *ngIf="entityUnread > 0" class="cl-subtab-badge">
            {{ entityUnread > 99 ? '99+' : entityUnread }}
          </span>
        </button>
      </div>

      <div class="cl-section" *ngIf="showGroupChannels">
        <div class="cl-section-label" *ngIf="viewTab === 'all' || viewTab === 'channels'">
          <span>{{ viewTab === 'channels' ? 'Group Channels' : 'Channels' }}</span>
          <button class="cl-add-btn" (click)="openNewChannelDialog()" title="New channel">
            <i class="pi pi-plus"></i>
          </button>
        </div>
        <div
          *ngFor="let ch of filteredGroup"
          class="cl-item"
          [class.cl-item--active]="isChannelOpenOrActive(ch.id)"
          (click)="selectChannel(ch)"
          >
          <span class="cl-item-avatar" [class.cl-item-avatar--no-image]="!ch.profile_pic_url">
            <span class="cl-item-avatar-initials" aria-hidden="true">{{ getChannelDisplayName(ch).charAt(0).toUpperCase() }}</span>
            <img
              *ngIf="ch.profile_pic_url"
              [clAvatar]="ch.profile_pic_url"
              (error)="onAvatarError($event)"
              [alt]="getChannelDisplayName(ch)"
            />
          </span>
          <div class="cl-item-body">
            <span class="cl-item-name">{{ getChannelDisplayName(ch) }}</span>
            <span *ngIf="ch.last_message" class="cl-item-preview">{{ ch.last_message }}</span>
          </div>
          <span *ngIf="ch.unread_count > 0" class="cl-badge">{{ ch.unread_count }}</span>
        </div>
        <div
          *ngIf="groupHasMore"
          #groupSentinel
          class="cl-scroll-sentinel"
          aria-hidden="true"
        ></div>
        <div *ngIf="groupLoadingMore" class="cl-loading cl-loading--inline">
          <i class="pi pi-spin pi-spinner"></i>
        </div>
        <div *ngIf="filteredGroup.length === 0 && !loading && viewTab !== 'all'" class="cl-section-empty">
          No group channels
        </div>
      </div>

      <div class="cl-section" *ngIf="showEntityChannels && (viewTab === 'channels' || filteredEntity.length > 0 || entityHasMore || entityLoadingMore)">
        <div class="cl-section-label">
          <span>{{ viewTab === 'channels' ? 'Entity Linked' : 'Linked Channels' }}</span>
        </div>
        <div
          *ngFor="let ch of filteredEntity"
          class="cl-item"
          [class.cl-item--active]="isChannelOpenOrActive(ch.id)"
          (click)="selectChannel(ch)"
          >
          <span class="cl-item-avatar" [class.cl-item-avatar--no-image]="!ch.profile_pic_url">
            <span class="cl-item-avatar-initials" aria-hidden="true">{{ getChannelDisplayName(ch).charAt(0).toUpperCase() }}</span>
            <img
              *ngIf="ch.profile_pic_url"
              [clAvatar]="ch.profile_pic_url"
              (error)="onAvatarError($event)"
              [alt]="getChannelDisplayName(ch)"
            />
          </span>
          <div class="cl-item-body">
            <span class="cl-item-name">{{ getChannelDisplayName(ch) }}</span>
            <span *ngIf="ch.last_message" class="cl-item-preview">{{ ch.last_message }}</span>
          </div>
          <span *ngIf="ch.unread_count > 0" class="cl-badge">{{ ch.unread_count }}</span>
        </div>
        <div
          *ngIf="entityHasMore"
          #entitySentinel
          class="cl-scroll-sentinel"
          aria-hidden="true"
        ></div>
        <div *ngIf="entityLoadingMore" class="cl-loading cl-loading--inline">
          <i class="pi pi-spin pi-spinner"></i>
        </div>
        <div *ngIf="filteredEntity.length === 0 && !loading && viewTab === 'channels'" class="cl-section-empty">
          No entity-linked channels
        </div>
      </div>
    </ng-container>

    <!-- Contacts tab -->
    <div class="cl-section" *ngIf="showContactsSection">
      <div class="cl-section-label">
        <span>Contacts</span>
      </div>
      <div
        *ngFor="let user of filteredContacts"
        class="cl-item"
        (click)="onContactClick(user)"
        >
        <span class="cl-item-avatar" [class.cl-item-avatar--no-image]="!user.profile_pic_url">
          <span class="cl-item-avatar-initials" aria-hidden="true">{{ user.user_name.charAt(0).toUpperCase() }}</span>
          <img
            *ngIf="user.profile_pic_url"
            [clAvatar]="user.profile_pic_url"
            (error)="onAvatarError($event)"
            [alt]="user.user_name"
          />
        </span>
        <div class="cl-item-body">
          <span class="cl-item-name">{{ user.user_name }}</span>
          <div class="dm-result-email-role">
            <span *ngIf="user.email" class="cl-item-preview">
              {{ user.email }}
            </span>
            <span *ngIf="user.role_name" class="dm-result-role">
              {{ user.role_name }}
            </span>
          </div>
        </div>
      </div>
      <div
        *ngIf="contactsHasMore"
        #contactsSentinel
        class="cl-contacts-sentinel"
        aria-hidden="true"
      ></div>
      <div *ngIf="contactsLoading || contactsLoadingMore" class="cl-loading">
        <i class="pi pi-spin pi-spinner"></i>
      </div>
      <div *ngIf="!contactsLoading && filteredContacts.length === 0" class="cl-section-empty">
        No contacts found
      </div>
    </div>

    <div *ngIf="loading && !showContactsSection" class="cl-loading">
      <i class="pi pi-spin pi-spinner"></i>
    </div>
  </div>
</div>

<!-- ─── New Group Channel Dialog ─────────────────────────────────────────── -->
<p-dialog
  [(visible)]="showNewChannelDialog"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '400px' }"
  header="New Channel"
  appendTo="body"
>
  <div class="new-channel-form">
    <label class="nc-label">Channel name</label>
    <input
      pInputText
      type="text"
      placeholder="e.g. general, announcements…"
      [(ngModel)]="newChannelName"
      class="nc-input"
      (keyup.enter)="createNewChannel()"
      autofocus
    />
  </div>
  <ng-template pTemplate="footer">
    <button
      pButton
      label="Cancel"
      class="cancel-btn"
      (click)="showNewChannelDialog = false"
    ></button>
    <button
      pButton
      label="Create"
      class="ms-2 save-btn"
      [disabled]="!newChannelName.trim() || creating"
      [loading]="creating"
      (click)="createNewChannel()"
    ></button>
  </ng-template>
</p-dialog>

<!-- ─── New DM Dialog ────────────────────────────────────────────────────── -->
<p-dialog
  [(visible)]="showNewDmDialog"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="true"
  [style]="{ width: '420px' }"
  styleClass="new-dm-dialog"
  header="New Direct Message"
  appendTo="body"
>
  <div class="new-dm-form">
    <!-- <label class="nc-label">Search by name or email</label> -->
    <div class="dm-search-wrap">
      <i class="pi pi-search dm-search-icon"></i>
      <input
        pInputText
        type="text"
        placeholder="Search by name or email"
        [(ngModel)]="dmSearchQuery"
        (ngModelChange)="onDmSearchInput()"
        class="nc-input"
        [disabled]="creating"
        autofocus
      />
      <i *ngIf="dmSearching" class="pi pi-spin pi-spinner dm-search-spin"></i>
    </div>

    <div class="dm-results" [class.dm-results--busy]="creating">
      <div
        *ngFor="let user of dmSearchResults"
        class="dm-result-item"
        [class.dm-result-item--disabled]="creating"
        [class.dm-result-item--creating]="creating && creatingDmUserId === user.user_id"
        (click)="startDm(user)"
      >
        <span class="dm-result-avatar">
          <span class="dm-result-avatar-initials" aria-hidden="true">{{ user.user_name.charAt(0).toUpperCase() }}</span>
          <img
            *ngIf="user.profile_pic_url && !(creating && creatingDmUserId === user.user_id)"
            [clAvatar]="user.profile_pic_url"
            [alt]="user.user_name"
          />
          <i
            *ngIf="creating && creatingDmUserId === user.user_id"
            class="pi pi-spin pi-spinner dm-result-avatar-spinner"
          ></i>
        </span>
        <div class="dm-result-info">
          <span class="dm-result-name">{{ user.user_name }}</span>
          <div class="dm-result-email-role">
            <span class="dm-result-email">
              {{ user.email }}
            </span>
          
            <span class="dm-result-role">
              {{ user.role_name }}
            </span>
          </div>
        </div>
      </div>
      <div
        *ngIf="dmHasMore"
        #dmSentinel
        class="dm-scroll-sentinel"
        aria-hidden="true"
      ></div>
      <div *ngIf="dmLoadingMore" class="dm-loading-more">
        <i class="pi pi-spin pi-spinner"></i>
      </div>
      <div
        *ngIf="!dmSearching && !dmLoadingMore && dmSearchQuery.length >= 2 && dmSearchResults.length === 0"
        class="dm-no-results"
      >
        No users found
      </div>
    </div>
  </div>
</p-dialog>
